module.exports = __webpack_public_path__ + "img/dots_rbb4.9e2fee82.png";